import { useQuery } from '@apollo/client/react';
import { WorkflowType } from 'shared/domains/apollo/generated/types';
import { MatchWorkflowsForDocumentDocument } from './MatchWorkflowsForDocument.gql';
import { MatchedWorkflowsDocument } from './MatchedWorkflows.gql';
export const useMatchWorkflowsForDocument = (documentId) => {
    const { data, loading, error } = useQuery(MatchWorkflowsForDocumentDocument, {
        variables: { documentId },
        fetchPolicy: 'network-only',
    });
    const results = (data === null || data === void 0 ? void 0 : data.matchWorkflows) || [];
    const workflowIds = results.map((result) => result.workflowId);
    const { data: workflowsData, loading: workflowsLoading, error: workflowsError, } = useQuery(MatchedWorkflowsDocument, {
        variables: { workflowIds },
        skip: workflowIds.length === 0,
        fetchPolicy: 'network-only',
    });
    const allWorkflows = (workflowsData === null || workflowsData === void 0 ? void 0 : workflowsData.workflows) || [];
    const matchingWorkflows = allWorkflows
        .filter((w) => workflowIds.includes(w.id))
        .map((w) => {
        var _a;
        return ({
            id: w.id,
            type: w.type === WorkflowType.ApprovalRequirementCheck ? 'approval' : 'signatory',
            name: ((_a = w.versions[0]) === null || _a === void 0 ? void 0 : _a.name) || w.id,
        });
    });
    return {
        loading: loading || workflowsLoading,
        error: error || workflowsError,
        approvalWorkflows: matchingWorkflows.filter((w) => w.type === 'approval'),
        signatoryWorkflows: matchingWorkflows.filter((w) => w.type === 'signatory'),
    };
};
